export default "__VITE_ASSET__CCbjVfGM__"